import React, { ReactNode } from "react";
import { Link } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

interface Props {
  slug: string;
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  clickable?: boolean;
}

export default function StatementLink({
  slug,
  children,
  className,
  onClick,
  clickable = true,
}: Props) {
  if (!clickable) return <>{children}</>;

  return (
    <Link
      component={RouterLink}
      to={slug}
      className={className}
      onClick={onClick}
    >
      {children}
    </Link>
  );
}
